import { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import api from 'src/redux/config';

// Statut de l'abonnement de l'entreprise (GET /company/subscription/status) : blocage du
// paiement (blockingEnabled, usable…) et fonctionnalités du pack (packFeaturesEnabled,
// features). Chargé une fois ici et partagé par ProtectedRoute, le menu et les pages.
export const PackFeaturesContext = createContext({
  status: null,
  loaded: false,
  hasFeature: () => true
});

export const PackFeaturesProvider = ({ children }) => {
  const authUser = useSelector((x) => x.user);
  const company = authUser.profile?.company;
  // L'admin reçoit l'entreprise peuplée, les autres comptes parfois son seul identifiant.
  const companyId = company?._id || company;
  const [status, setStatus] = useState(null);
  // Réponse reçue (ou échec) : tant qu'il est faux, le pack n'est pas connu. Le menu attend
  // pour charger les badges des fonctionnalités, qui répondraient 403 hors du pack.
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!authUser.accessToken || !companyId) {
      setStatus(null);
      // Profil réellement chargé (il démarre à {}) et sans entreprise : rien à attendre.
      setLoaded(Boolean(authUser.profile?._id));
      return undefined;
    }
    let cancelled = false;
    setLoaded(false);
    api
      .get('/company/subscription/status')
      .then(({ data }) => !cancelled && setStatus(data))
      .catch(() => !cancelled && setStatus(null))
      .finally(() => !cancelled && setLoaded(true));
    return () => {
      cancelled = true;
    };
  }, [authUser.accessToken, companyId, authUser.profile?._id]);

  // Vérification des packs désactivée côté back-end (PACK_FEATURES_ENABLED) ou statut
  // illisible : tout reste visible, comme avant. Les écrans attendent `loaded`.
  const hasFeature = (feature) =>
    !status?.packFeaturesEnabled ||
    !Array.isArray(status.features) ||
    status.features.includes(feature);

  return (
    <PackFeaturesContext.Provider value={{ status, loaded, hasFeature }}>
      {children}
    </PackFeaturesContext.Provider>
  );
};

export const usePackFeatures = () => useContext(PackFeaturesContext);
